import {ENV_LABEL} from 'envs/_current/config'
import _ from 'lodash'
import React, {useContext} from 'react'
import {Link} from 'react-router-dom'
import {AppTextLogoSvg} from "../../appConfigs/svgs/AppTextLogoSvg";
import {LayoutContext} from "../layouts/Default/LayoutContext";

export const AppTextLogoIcon = ({to = "/start"}) => {

    return (
        <Link
            to={to}
            style={{
                fontSize: '1em',
                height: 'var(--header-height)'
            }}
            className="flex items-center gap-1">
            <AppTextLogoSvg size={16}/>
            {!_.isEmpty(ENV_LABEL) && (
                <div className="p-1 rounded text-2xs font-bold text-orange-500">
                    {ENV_LABEL}
                </div>
            )}
        </Link>
    )
}
